import { useContext, useEffect, useRef, useState } from 'react';

import { RightContext } from '@/components/RightProvider/context';
import UserStore from '@/store/User';

import { ViralTemplateTab } from './useViralTemplateRouteState';

/**
 * 仅在 myCreations 场景做登录态检查。
 * 目标是让 template-list 保持匿名可访问，同时避免重复触发登录请求。
 */
export const useMyCreationsLoginGate = (activeMainTab: ViralTemplateTab) => {
  const rightContext = useContext(RightContext);
  const [isLoggedIn, setIsLoggedIn] = useState(() =>
    activeMainTab === ViralTemplateTab.MY_CREATIONS
      ? UserStore.getState().getLoginState()
      : false,
  );
  const checkingLoginRef = useRef(false);

  useEffect(() => {
    if (activeMainTab !== ViralTemplateTab.MY_CREATIONS) {
      return;
    }

    const checkLogin = async () => {
      if (checkingLoginRef.current) return;
      checkingLoginRef.current = true;
      try {
        /** 未登录时主动弹登录框 */
        const ok = await rightContext.getUserLoginState();
        setIsLoggedIn(ok);
      } finally {
        checkingLoginRef.current = false;
      }
    };

    void checkLogin();
  }, [activeMainTab, rightContext]);

  return { isLoggedIn };
};
